<h3 class="text-center">{{ 'feature.song.uploaded_song' | translate }}</h3>

<hr />
<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">{{ 'common.label.title' | translate }}</th>
      <th scope="col"></th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr [routerLink]="['/song', 'detail']" [queryParams]="{id: song.id}" *ngFor="let song of songPage.content; index as i">
      <th scope="row">{{ song.rn }}</th>
      <td>
        <a [routerLink]="['/song','detail']" [queryParams]="{id: song.id}"><h5>{{song.title}}</h5></a>
        <a *ngFor="let artist of song.artists; index as j"
          ><small>{{ artist.name }}{{ j === song.artists.length - 1 ? '' : ', '}}</small></a
        >
      </td>
      <td>
        <small>{{ song.duration | duration }}</small>
      </td>
      <td>
        <button class="btn btn-info btn-sm rounded-circle mx-1" (click)="addToPlaying(song, $event)" [disabled]="song.isDisabled">
          <i class="bi bi-play"></i>
        </button>
        <a class="btn btn-secondary btn-sm rounded-circle mx-1" [routerLink]="['/song','edit']" [queryParams]="{id: song.id}"
          ><i class="bi bi-pencil-square"></i
        ></a>
      </td>
    </tr>
  </tbody>
</table>
<ngb-pagination
  *ngIf="songPage.totalPages > 1"
  [collectionSize]="songPage.totalElements"
  [page]="songPage.pageable?.pageNumber + 1"
  [pageSize]="songPage.pageable?.pageSize"
  (pageChange)="getUserSongUploadedPage($event - 1)"
></ngb-pagination>
